<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
    <BannerForm :baseBanner="banner" :loading="loading" @submit-requested="submitRequested"></BannerForm>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { API_HELPER } from "@/helpers/api.js";
import BannerForm from './BannerForm.vue'

export default {
  components: { BannerForm },
  data() {
    return {
      banner: null,
      loading: false
    }
  },
  computed: {
    ...mapState('banners', ['getBannerByIdOutput']),
    ...mapState('banners', ['putBannerOutput'])
  },
  mounted: function() {
    this.loadBanner();
  },
  methods: {
    ...mapActions('banners', ['getBannerById']),
    ...mapActions('banners', ['putBanner']),
    loadBanner() {
      const id = this.$route.query.id;
      if (id) {
        this.loading = true;
        this.getBannerById(id);
      }
    },
    submitRequested (input) {
      this.putBanner(input);
    }
  },
  watch: {
    getBannerByIdOutput: function() {
      if (this.getBannerByIdOutput && this.getBannerByIdOutput.succeeded) {
        const apiData = this.getBannerByIdOutput.data;
        const bannerData = {
          id: apiData.id,
          imageUrl: apiData.imageUrl,
          image: apiData.imageUrl ? { url: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, apiData.imageUrl]) } : null,
          link: apiData.link || '',
          active: apiData.active,
          position: apiData.position,
          altTexts: {
            1: apiData.altTexts.pt || '',
            2: apiData.altTexts.en || '',
            3: apiData.altTexts.es || ''
          }
        };
        this.banner = bannerData;
        this.loading = false;
      }
    }
  }
}
</script>
